import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HappyHumanToolsApp } from './components/HappyHumanToolsApp';
import { ArchitectureDiagram } from './components/ArchitectureDiagram';
import { ProjectStructure } from './components/ProjectStructure';
import { SESQuest } from './components/SESQuest';
import { SESQuestReal } from './components/SESQuestReal';
import { AWSSignupWizard } from './components/AWSSignupWizard';
import { DomainManager } from './components/DomainManager';
import DomainManagerEnhanced from './components/DomainManagerEnhanced';
import DomainManagerSuper from './components/DomainManagerSuper';
import ShareableLinkManager from './components/ShareableLinkManager';
import PublicUploadPage from './components/PublicUploadPage';
import { IAMPermissionPalace } from './components/IAMPermissionPalace';
import { EmailSender } from './components/EmailSender';
import { SendEmailWithFileShare } from './components/SendEmailWithFileShare';
import { TaxPreparerFileRequest } from './components/TaxPreparerFileRequest';
import { CompleteImplementationSteps } from './components/CompleteImplementationSteps';
import { ClientFolderManager } from './components/ClientFolderManager';
import { ShareAccessPortal } from './components/ShareAccessPortal';
import { FolderCreationSteps } from './components/FolderCreationSteps';
import { LinksDirectory } from './components/LinksDirectory';
import { ProjectFileExplorer } from './components/ProjectFileExplorer';
import { DeploymentSteps } from './components/DeploymentSteps';
import { HappyHumanToolsSESSetup } from './components/HappyHumanToolsSESSetup';
import BusinessFileSharing from './components/BusinessFileSharing';
import BusinessUploadPortal from './components/BusinessUploadPortal';
import BusinessFileSharingSteps from './components/BusinessFileSharingSteps';
import BusinessFileSharingInteractive from './components/BusinessFileSharingInteractive';
import TaxPreparerWorkflowDesigner from './components/TaxPreparerWorkflowDesigner';
import { UploadLinkManager } from './components/UploadLinkManager';
import { D1PublicUploadPage } from './components/D1PublicUploadPage';
import SimpleFileReceiver from './components/SimpleFileReceiver';
import ReceiverCreated from './components/ReceiverCreated';
import FastFilesLanding from './components/FastFilesLanding';
import FastFilesDashboard from './components/FastFilesDashboard';
import ShareFiles from './components/ShareFiles';
import ArchitectureViewResponsive from './components/ArchitectureViewResponsive';
import InteractiveArchitectureExplorer from './components/InteractiveArchitectureExplorer';

function App() {
  return (
    <Routes>
      <Route path="/" element={<ShareFiles />} />
      <Route path="/tools" element={<HappyHumanToolsApp />} />
      <Route path="/architecture" element={<ArchitectureDiagram />} />
      <Route path="/architecture-flow" element={<ArchitectureViewResponsive />} />
      <Route path="/explorer" element={<InteractiveArchitectureExplorer />} />
      <Route path="/structure" element={<ProjectStructure />} />
      <Route path="/ses-quest" element={<SESQuest />} />
      <Route path="/ses-real" element={<SESQuestReal />} />
      <Route path="/aws-signup" element={<AWSSignupWizard />} />
      <Route path="/iam-setup" element={<IAMPermissionPalace />} />
      <Route path="/domains" element={<DomainManager />} />
      <Route path="/domains-enhanced" element={<DomainManagerEnhanced />} />
      <Route path="/domains-super" element={<DomainManagerSuper />} />
      <Route path="/share-links" element={<ShareableLinkManager />} />
      <Route path="/upload/:shortCode" element={<PublicUploadPage />} />
      <Route path="/send-email" element={<TaxPreparerFileRequest />} />
      <Route path="/files" element={<ClientFolderManager />} />
      <Route path="/share/:linkId" element={<ShareAccessPortal />} />
      <Route path="/folder-steps" element={<FolderCreationSteps />} />
      <Route path="/links" element={<LinksDirectory />} />
      <Route path="/project-files" element={<ProjectFileExplorer />} />
      <Route path="/deployment-steps" element={<DeploymentSteps />} />
      <Route path="/ses-setup" element={<HappyHumanToolsSESSetup />} />
      <Route path="/business-files" element={<BusinessFileSharing />} />
      <Route path="/business-files-steps" element={<BusinessFileSharingSteps />} />
      <Route path="/business-files-interactive" element={<BusinessFileSharingInteractive />} />
      <Route path="/tax-preparer-workflow" element={<TaxPreparerWorkflowDesigner />} />
      <Route path="/files/:businessSlug" element={<BusinessUploadPortal />} />
      <Route path="/implementation-steps" element={<CompleteImplementationSteps />} />
      <Route path="/d1-upload-links" element={<UploadLinkManager />} />
      <Route path="/upload/:slug" element={<D1PublicUploadPage />} />
      <Route path="/create-receiver" element={<SimpleFileReceiver />} />
      <Route path="/receiver-created/:slug" element={<ReceiverCreated />} />
      <Route path="/file-inbox" element={<FastFilesLanding />} />
      <Route path="/dashboard" element={<FastFilesDashboard />} />
    </Routes>
  );
}

export default App;
